import {computed, onBeforeMount, onBeforeUnmount, ref, watch} from 'vue';
import {storeToRefs} from 'pinia';
import {useAuth, useProfileTracking, useRoute} from '#imports';
import {eventBus} from '~/config/events';
import {RecommendationEmailLinkOpenedRecommenderStatus} from '~/config/TrackingEvents';
import {useProfileStore} from '~/store/profileStore';

export function useAddRecommendationQueryParam() {
    const route = useRoute();

    const profileStore = useProfileStore();
    const {profile} = storeToRefs(profileStore);
    const authStore = useAuth();
    const {loggedIn} = storeToRefs(authStore);

    const {trackRecommendationEmailLinkOpened} = useProfileTracking();
    const hasARecommendationQueryParam = ref(Object.prototype.hasOwnProperty.call(route.query, 'ra'));
    const isReadyToOpenDrawerAddRecommendation = ref(false);
    const isProfileConsultedByAnotherLoggedInUser = computed<boolean>(() => profile.value?.editMode === false && loggedIn.value === true);

    onBeforeMount(() => {
        if (isProfileConsultedByAnotherLoggedInUser.value && hasARecommendationQueryParam.value) {
            eventBus.on('external-action:recommendations:ready', handleExternalActionRecommendationsReady);
        }
    });
    onBeforeUnmount(() => {
        eventBus.off('external-action:recommendations:ready', handleExternalActionRecommendationsReady);
    });

    function handleExternalActionRecommendationsReady() {
        isReadyToOpenDrawerAddRecommendation.value = true;
    }

    watch([hasARecommendationQueryParam, isReadyToOpenDrawerAddRecommendation], () => {
        if (hasARecommendationQueryParam.value && isReadyToOpenDrawerAddRecommendation.value) {
            eventBus.emit('external-action:recommendations:add', {experienceId: route.query.raExpId ? route.query.raExpId.toString() : ''});
            const comesFromSignup = document.referrer && document.referrer.includes(window.location.host) && document.referrer.includes('signup');
            const recommenderStatus = comesFromSignup
                ? RecommendationEmailLinkOpenedRecommenderStatus.NEW_ACCOUNT_CREATED
                : RecommendationEmailLinkOpenedRecommenderStatus.LOGGED_IN;
            trackRecommendationEmailLinkOpened(profile.value!.profileId, recommenderStatus);
        }
    });
}
